import PropTypes from 'prop-types';
import React from 'react';

const Thermometer = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    className={className}
  >
    <circle
      cx="7.4967"
      cy="15.29"
      r="1.2593"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="7.4967"
      y1="7.6814"
      x2="7.4967"
      y2="13.7391"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="5.5859"
      y1="3.6877"
      x2="6.9989"
      y2="3.6877"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="5.5859"
      y1="5.7003"
      x2="6.9989"
      y2="5.7003"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.4076,12.6874V3.238a1.9129,1.9129,0,0,0-3.8217,0v9.4494A3.1089,3.1089,0,0,0,4.1912,15.259a3.2329,3.2329,0,0,0,3.3055,3.1551,3.233,3.233,0,0,0,3.3056-3.1551A3.1089,3.1089,0,0,0,9.4076,12.6874Z"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12.1614"
      y1="5.7273"
      x2="16.2406"
      y2="5.7273"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="14.201"
      y1="7.7669"
      x2="14.201"
      y2="3.6877"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12.1614"
      y1="10.4076"
      x2="16.2406"
      y2="10.4076"
      fill="none"
      stroke="#1e1e1e"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Thermometer.propTypes = {
  className: PropTypes.string,
};

export default Thermometer;
